import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "../components/Reveal";
import { Counter } from "../components/Counter";
import { WHY_US, STATS } from "../data/content";
import { WHY_IMGS } from "../data/images";

export default function WhyUs() {
  return (
    <main className="pt-28">
      <section data-testid="why-us-page-section" className="section-pad !pt-8">
        <div className="container-x">
          <SectionHead badge="Why VAELIX" title="Why Choose VAELIX TECHNOLOGY"
            sub="Fourteen reasons businesses trust us with their most critical systems — and keep coming back." />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {WHY_US.map((w, i) => {
              const Icon = Icons[w.icon] || Icons.Sparkles;
              return (
                <motion.div key={w.title} data-testid={`why-us-page-card-${i}`}
                  initial={{ opacity: 0, y: 26 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.45, delay: (i % 3) * 0.08 }} whileHover={{ y: -6 }}
                  className="glass-card rounded-2xl overflow-hidden">
                  <img src={WHY_IMGS[i]} alt={w.title}
                    className="w-full h-32 object-cover" />
                  <div className="p-6">
                  <span className="w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-500 text-white flex items-center justify-center shadow-[0_8px_24px_rgba(99,102,241,0.35)]">
                    <Icon size={22} />
                  </span>
                  <h3 className="mt-4 font-display font-semibold text-lg">{w.title}</h3>
                  <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{w.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <section data-testid="why-us-stats-section" className="section-pad bg-secondary/40 border-y border-border/60">
        <div className="container-x">
          <SectionHead badge="Proof in Numbers" title="Results That Speak for Themselves" />
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
            {STATS.map((s, idx) => (
              <Reveal key={s.label} delay={idx * 0.08} className="text-center">
                <p className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gradient">
                  <Counter value={s.value} suffix={s.suffix} />
                </p>
                <p className="mt-2 text-sm text-muted-foreground font-medium">{s.label}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="why-us-cta-section" className="section-pad">
        <div className="container-x">
          <Reveal>
            <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-indigo-900 via-blue-950 to-slate-950 border border-indigo-500/30 px-8 py-14 sm:px-14 text-center">
              <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[420px] h-[420px] rounded-full bg-indigo-500/25 blur-[110px]" aria-hidden="true" />
              <h2 className="relative text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-tight">Experience the VAELIX difference</h2>
              <p className="relative mt-4 text-slate-300 max-w-xl mx-auto">Book a free consultation and see why 50+ clients rate us 5 stars.</p>
              <Link to="/contact" data-testid="why-us-cta-btn"
                className="relative mt-8 inline-flex items-center gap-2 rounded-full bg-white text-indigo-950 px-7 py-3.5 text-sm font-bold hover:-translate-y-0.5 hover:shadow-[0_12px_40px_rgba(255,255,255,0.25)] transition-all duration-200">
                Book Consultation <ArrowRight size={16} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
